<template>
  <div class="page">
    <van-nav-bar :title="$t('video.video')" class="header_b" />

    <div class="maintain">
      <!-- 大图标（内置 SVG，不依赖图片资源） -->
      <div class="maintain-icon" aria-hidden="true">
        <svg viewBox="0 0 512 512" width="120" height="120">
          <path
            fill="#F2C94C"
            d="M501.1 106.9c-13.6-13.6-35.7-13.6-49.3 0l-49.7 49.7-63.6-63.6 49.7-49.7c13.6-13.6 13.6-35.7 0-49.3-13.6-13.6-35.7-13.6-49.3 0l-72.5 72.5c-10.9 10.9-13 27.4-6.3 40.5L41.7 386.8c-9.4 9.4-14.6 21.8-14.6 35.1v47.6c0 22.4 18.2 40.6 40.6 40.6h47.6c13.3 0 25.7-5.2 35.1-14.6l227.3-227.3c13.1 6.7 29.6 4.6 40.5-6.3l72.5-72.5c13.6-13.6 13.6-35.7 0-49.3zM126.9 470.8c-3.2 3.2-7.5 5-12.1 5H67.2c-9.5 0-17.2-7.7-17.2-17.2V411c0-4.6 1.8-8.9 5-12.1l212.2-212.2 36.4 36.4-212.3 212.7z"
          />
        </svg>
      </div>

      <div class="maintain-title">
        {{ $t('video.maint_title') }}
      </div>

      <div class="maintain-desc">
        {{ $t('video.maint_desc') }}
      </div>

      <div class="maintain-card">
        <div class="card-row">
          <div class="card-ico">
            <van-icon name="calendar-o" />
          </div>
          <div class="card-text">
            <div class="card-h">{{ $t('video.maint_time_title') }}</div>
            <div class="card-p">{{ $t('video.maint_time_desc') }}</div>
          </div>
        </div>

        <div class="card-row">
          <div class="card-ico">
            <van-icon name="setting-o" />
          </div>
          <div class="card-text">
            <div class="card-h">{{ $t('video.maint_content_title') }}</div>
            <div class="card-p">{{ $t('video.maint_content_desc') }}</div>
          </div>
        </div>
      </div>

      <div class="progress-wrap">
        <div class="progress-top">
          <span class="progress-label">{{ $t('video.maint_progress') }}</span>
          <span class="progress-percent">{{ progress }}%</span>
        </div>
        <div class="progress-track">
          <div class="progress-bar" :style="{ width: progress + '%' }"></div>
        </div>
      </div>
    </div>

    <div style="height: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 你想改进度就改这里
      progress: 36,
    };
  },
};
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}

.van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}

.header_b {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.maintain {
  padding: 120px 30px 20px;
  text-align: center;
}

.maintain-icon {
  display: flex;
  justify-content: center;
  margin: 40px 0 20px;
}

.maintain-title {
  color: #f3c7a2;
  font-size: 42px;
  font-weight: 700;
  margin-top: 10px;
}

.maintain-desc {
  color: rgba(255, 255, 255, 0.75);
  font-size: 24px;
  line-height: 1.6;
  margin: 18px auto 28px;
  max-width: 720px;
}

.maintain-card {
  margin: 0 auto;
  padding: 26px 24px;
  border-radius: 18px;
  border: 1px solid #766350;
  background: linear-gradient(120deg, #212121, #313131);
  max-width: 760px;
  text-align: left;
}

.card-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 14px 0;
}

.card-row + .card-row {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.card-ico {
  color: #f3c7a2;
  font-size: 34px;
  margin-top: 2px;
  width: 36px;
  flex: 0 0 36px;
}

.card-h {
  color: #f3c7a2;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
}

.card-p {
  color: rgba(255, 255, 255, 0.72);
  font-size: 22px;
  line-height: 1.6;
}

.progress-wrap {
  max-width: 760px;
  margin: 26px auto 0;
}

.progress-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 22px;
  margin-bottom: 10px;
}

.progress-track {
  height: 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  border-radius: 999px;
  background: #24c36a;
}
</style>
